import { type JSX, createEffect, createMemo, createSignal, on } from "solid-js";

import "@/styles/motion/slide.css";

type ExpandAnimationWrapperProps = {
  state: boolean;
  children: JSX.Element;
  direction?: "horizontal" | "vertical";
  onAnimationEnd?: () => void;
};

// 自定义 Hook：管理下拉菜单的通用逻辑
export function useDropdownMenu() {
  const [isOpen, setIsOpen] = createSignal(false);
  const [isAnimating, setIsAnimating] = createSignal(false);

  // 只有在非动画状态时才能切换
  const toggleDropdown = () => {
    if (!isAnimating()) {
      setIsOpen(!isOpen());
      // if (isOpen()) getUserInfo();
    }
  };

  // 开始关闭动画
  const startCloseAnimation = () => {
    if (isOpen() && !isAnimating()) {
      setIsAnimating(true);
      setIsOpen(false);
    }
  };

  // 动画完成回调
  const handleAnimationEnd = () => {
    setIsAnimating(false);
  };

  // 直接关闭（不执行动画）
  const closeDropdown = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    isAnimating,
    toggleDropdown,
    startCloseAnimation,
    handleAnimationEnd,
    closeDropdown,
  };
}

export function AnimationMenuSlide(props: ExpandAnimationWrapperProps) {
  const [expanded, setExpanded] = createSignal(false);
  const [isAnimating, setIsAnimating] = createSignal(false);

  createEffect(
    on(
      createMemo(() => props.state),
      (boolean) => {
        if (boolean) {
          setExpanded(true);
          setIsAnimating(false);
        } else {
          setIsAnimating(true);
          setExpanded(false);
        }
      },
    ),
  );

  const handleAnimationEnd = () => {
    if (!expanded() && isAnimating()) {
      setIsAnimating(false);
      props.onAnimationEnd?.();
    }
  };

  return (
    <div
      class={expanded() ? "slideUpIn" : "slideUpOut"}
      onAnimationEnd={handleAnimationEnd}
      style={{
        display: "grid",
        "grid-template-rows": "1fr",
        "grid-template-columns": "1fr",
        overflow: "hidden",
        "pointer-events": "auto",
        "will-change": "grid-template-columns, grid-template-rows",
        "white-space": "normal",
      }}
    >
      <div style={{ overflow: "hidden" }}>{props.children}</div>
    </div>
  );
}
